// Sample mission dossier cards — show how sponsorship works.
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

export const SAMPLE_MISSIONS = [
  {
    n: "001", title: "Beauty Editorial", status: "AWAITING SPONSOR",
    needed: ["Beauty products", "Wardrobe", "Studio access"],
    units: ["Photography", "Models", "Makeup", "Hair", "Styling", "Video", "Creative Direction"],
    cta: "Sponsor This Mission",
  },
  {
    n: "002", title: "Hotel Storytelling Campaign", status: "AWAITING LOCATION PARTNER",
    needed: ["Hotel room / suite access"],
    units: ["Photography", "Video", "Models", "Styling", "Social Media", "Writing", "Creative Direction"],
    cta: "Host This Mission",
  },
  {
    n: "003", title: "Creator Toolkit", status: "AWAITING EQUIPMENT PARTNER",
    needed: ["Camera equipment", "Lighting", "Editing tools", "Printing services"],
    units: ["Photography", "Video", "Design", "Social Media", "Editing"],
    cta: "Equip This Mission",
  },
];

export const MissionCards = ({ ctaTo = "/transmission/industry" }) => (
  <div className="grid gap-5 md:grid-cols-3" data-testid="sample-mission-cards">
    {SAMPLE_MISSIONS.map((m, i) => (
      <Reveal key={m.n} delay={i * 0.08}>
        <div className="group flex h-full flex-col border border-silver/20 bg-charcoal/70 transition-all duration-300 hover:-translate-y-1 hover:border-gold/50 hover:shadow-[0_0_30px_rgba(201,162,39,0.12)]" data-testid={`mission-card-${m.n}`}>
          <div className="border-b border-gold/20 p-5">
            <div className="flex items-start justify-between gap-3">
              <p className="font-cinzel text-[10px] uppercase tracking-[0.35em] text-gold">Mission {m.n}</p>
              <span className="shrink-0 -rotate-2 border border-gold/50 px-2 py-0.5 font-mono text-[8px] font-bold uppercase tracking-[0.15em] text-goldlight">
                {m.status}
              </span>
            </div>
            <h3 className="mt-3 font-display text-2xl uppercase leading-[0.95] tracking-tight text-cream transition-colors group-hover:text-goldlight">{m.title}</h3>
          </div>
          <div className="flex flex-1 flex-col p-5">
            <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-silver/50">Needed</p>
            <ul className="mt-2 space-y-1.5">
              {m.needed.map((x) => (
                <li key={x} className="flex gap-2 font-body text-sm text-silver/85">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rotate-45 bg-gold" aria-hidden="true" /> {x}
                </li>
              ))}
            </ul>
            <p className="mt-4 font-mono text-[9px] uppercase tracking-[0.3em] text-silver/50">Units activated</p>
            <div className="mt-2 flex flex-wrap gap-1.5">
              {m.units.map((u) => (
                <span key={u} className="border border-silver/25 bg-onyx px-2 py-0.5 font-mono text-[9px] uppercase tracking-[0.12em] text-silver/80">{u}</span>
              ))}
            </div>
            <Link to={ctaTo} data-testid={`mission-card-${m.n}-cta`}
              className="btn-sweep mt-auto block border border-gold bg-gradient-to-b from-goldlight to-gold px-4 py-3 text-center font-head text-xs font-extrabold uppercase tracking-[0.2em] text-onyx transition-transform duration-200 hover:-translate-y-0.5"
              style={{ marginTop: "1.25rem" }}>
              {m.cta}
            </Link>
          </div>
        </div>
      </Reveal>
    ))}
  </div>
);
